<template>
  <div v-if="user">
    <v-tooltip top color="primary lighten-2">
        <template v-slot:activator="{ props }">
        <div
            v-bind="props"
            data-hj-suppress
            class="user-bubble"
            :style="{
              'background-image': `url(${user.photo})`,
              'width': `${size || 48}px`,
              'height': `${size || 48}px`,
              'font-size': `${(size/2) || 24}px`,
            }"
        >
            <span v-if="!user.photo">{{ initials }}</span>
        </div>
        </template>
        <span>{{ name }}</span>
    </v-tooltip>
  </div>
</template>
<script>
export default {
  name: 'UserBubble',
  props: [
    'user',
    'size',
  ],
  data() {
    return {};
  },
  computed: {
    initials() {
      if (this.user.name) {
        return this.user.name
          .split(/\s/)
          .reduce((res, word) => res + word.slice(0, 1), '');
      }
      if (this.user.first_name && this.user.last_name) {
        return `${this.user.first_name[0]}${this.user.last_name[0]}`;
      }
      return '';
    },
    name() {
      if (this.user.name) {
        return this.user.name;
      }
      if (this.user.first_name && this.user.last_name) {
        return `${this.user.first_name} ${this.user.last_name}`;
      }
      return '';
    },
  },
};
</script>
<style>
.user-bubble {
  background: #afafaf;
  border-radius: 100%;
  font-weight: bold;
  align-items: center;
  justify-content: center;
  display: flex;
  cursor: pointer;
  background-size: cover;
  background-position: center center;
}
.user-bubble:hover {
  border: 1px solid gray;
}
</style>
